/**
 * @generated SignedSource<<ca2337a7e6910ec2024995afdb77323a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GivePointsModal_tenant$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GivePointsPaymentModal_tenant">;
  readonly " $fragmentType": "GivePointsModal_tenant";
};
export type GivePointsModal_tenant$key = {
  readonly " $data"?: GivePointsModal_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"GivePointsModal_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GivePointsModal_tenant",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GivePointsPaymentModal_tenant"
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "24bd4fea1d67f2e96e66ecdb3410ae62";

export default node;
